const API_URL = process.env.NODE_ENV === "production" 
    ? 'https://api.devkit.xyz'
    : 'http://dev.devkit.xyz';

export default API_URL;